import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";

@Component({
  selector: "app-testing-stub-page",
  templateUrl: "./testing-stub-page.component.html",
  styleUrls: ["./testing-stub-page.component.scss"],
})
export class TestingStubPageComponent {
  userEmail: string;

  constructor(
    private router: Router,
    private store: Store<AppState>,
  ) {
    store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.userEmail = data.userDetails ? data.userDetails.email : "";
        if (
          this.userEmail !== "" &&
          !this.userEmail.includes("@visiblealpha.com")
        ) {
          //redirect to home
          this.router.navigateByUrl("home");
        }
      });
  }
}
